<div
  [ngClass]="{ invalid: isErrored || initialError, opened: dropdownOpened }"
  [class]="theme !== 'light' ? 'select ' + theme : 'select'"
  appClickOutsideComponent
  [dontActivateIfModal]="dontActivateIfModal"
  (clickOutside)="dropdownOpened = false">
  <button class="select-button" [ngClass]="{'large': large, 'inputStyle': inputStyle}" (click)="toggleDropdown()">
    <div class="select-text">
      <div class="select-label" *ngIf="label">
        {{ label }}
        <div
          *ngIf="tooltipText"
          class="tooltip-container"
          ngbTooltip="{{ tooltipText | t }}"
          container="body"
          placement="top-right"
          tooltipClass="my-configurations-tooltip">
          <nb-icon icon="info" pack="icomoon"></nb-icon>
        </div>
      </div>
      <div class="select-placeholder" *ngIf="placeholder && selectedItems.length === 0">{{ placeholder }}</div>
      <div class="select-text-items">
        <ng-container *ngFor="let item of selectedItems; index as idx"
          >{{ item.translate ? (item.name | t ) : (idx !== 0 ? ', ' : '') + item.name }}</ng-container
        >
      </div>
    </div>
    <div class="select-icons">
      <nb-icon class="select-icons-error" icon="cross-circle" pack="icomoon" *ngIf="isErrored"></nb-icon>
      <nb-icon
        class="select-icons-clear"
        icon="basket-filled"
        pack="icomoon"
        *ngIf="selectedItems.length > 0 && showClear"
        (click)="clearSelection($event)"></nb-icon>
      <nb-icon class="select-icons-chevron" [ngClass]="{ active: dropdownOpened }" icon="chevron-down" pack="icomoon"></nb-icon>
    </div>
  </button>
  <span class="select-error-message" *ngIf="required && isErrored && !dropdownOpened">{{ 'this_field_is_required' | t }}</span>
  <span class="select-error-message" *ngIf="initialError && !dropdownOpened">{{ 'error_wrong_value' | t }} {{ 'error_campaign_unavailable' | t }}</span>
  <div class="options-container" *ngIf="dropdownOpened">
    <div class="select-search" *ngIf="search">
      <div class="select-search-field">
        <app-search-input [placeholder]="'search'" (inputValue)="debouncedSearch($event)"></app-search-input>
      </div>
    </div>
    <ul class="options">
      <li class="option" *ngFor="let option of filteredOptions">
        <button class="option-button" [ngClass]="{ checked: isOptionSelected(option) }" (click)="toggleOptionPick(option)">
          <ng-container *ngIf="!removeCheckbox">
            <span class="option-check-icon" [ngClass]="{ checked: isOptionSelected(option) }">
              <nb-icon *ngIf="isOptionSelected(option)" icon="check" pack="icomoon"></nb-icon>
            </span>
          </ng-container>
          <span class="option-text">
            <ng-container *ngIf="option.icon">
              <nb-icon class="option-icon" [icon]="option.icon" pack="icomoon"></nb-icon>
            </ng-container>
            <ng-container *ngIf="option.icons">
              <ng-container *ngIf="option.icons.includes('desktop')">
                <nb-icon class="option-icons" icon="device-desktop" pack="icomoon"></nb-icon>
              </ng-container>
              <ng-container *ngIf="option.icons.includes('android')">
                <img ngSrc="assets/icons/devices/android.png" alt="android" height="16" width="16" class="option-icons" />
              </ng-container>
              <ng-container *ngIf="option.icons.includes('ios')">
                <img ngSrc="assets/icons/devices/ios.png" alt="ios" height="16" width="16" class="option-icons" />
              </ng-container>
            </ng-container>
            <ng-container *ngIf="option.img">
              <img class="option-image" [src]="option.img" [alt]="'view_translations.flag' | translate: { country: option.name }" />
            </ng-container>
            {{ option.translate ? (option.name | t) : option.name }}
          </span>
          <span class="option-details" *ngIf="extraButton">
            <app-open-details-modal-button [data]="option.extraData"> </app-open-details-modal-button>
          </span>
        </button>
      </li>
    </ul>
  </div>
</div>
